import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios, { Canceler } from "axios";
import { Anime, JikanResponse } from "../../types";

let cancel: Canceler;

export const fetchAnime = createAsyncThunk(
  'anime/fetchAnime',
  async ({ query, page }: { query: string; page: number }) => {
    if (cancel) cancel(); // cancel previous
    const source = axios.CancelToken.source();
    cancel = source.cancel;
    const { data } = await axios.get<JikanResponse>(
      `https://api.jikan.moe/v4/anime?q=${query}&page=${page}&limit=24`,
      { cancelToken: source.token }
    );
    return data;
  }
);

export const fetchAnimeDetail = createAsyncThunk(
  'anime/fetchDetail',
  async (id: string) => {
    const { data } = await axios.get<{ data: Anime }>(
      `https://api.jikan.moe/v4/anime/${id}`
    );
    return data.data;          // strip wrapper
  }
);

interface AnimeState {
    items: Anime[];
    loading: boolean;
    error: string | null;
    page: number;
    hasNext: boolean;
    detail: Anime | null;
    detailLoading: boolean;
    detailError: string | null;
}

const initialState: AnimeState = {
    items: [],
    loading: false,
    error: null,
    page: 1,
    hasNext: false,
    detail: null,
    detailLoading: false,
    detailError: null
}

const animeSlice = createSlice({
    name: 'anime',
    initialState,
    reducers: {
      clearResults: (state) => {
      state.items = [];          // wipe old cards instantly
      state.page = 1;            // optional: reset page
      state.hasNext = false;
    },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAnime.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAnime.fulfilled, (state, action) => {
                state.loading = false;
                state.items = action.payload.data;
                state.hasNext = action.payload.pagination.has_next_page;
                state.page = action.meta.arg.page;
            })
            .addCase(fetchAnime.rejected, (state,action) => {
                state.loading = false;
                state.error = action.error.message ?? 'Network Error';
            })
            .addCase(fetchAnimeDetail.pending, (state) => {
                state.detailLoading = true;
                state.detailError = null;
                })
            .addCase(fetchAnimeDetail.fulfilled, (state, action) => {
                state.detailLoading = false;
                state.detail = action.payload;
                })
            .addCase(fetchAnimeDetail.rejected, (state, action) => {
                state.detailLoading = false;
                state.detailError = action.error.message ?? 'Failed to load details';
                });
            
    },
});
export const { clearResults } = animeSlice.actions;
export default animeSlice.reducer;
